import React from 'react';
import { SubTitle } from './../../../common/sharedComponents/SubTitle';
import { Headline3 } from '../../../common/typography';
import { ITabContent } from '../../../@types/tabContent';
import {
  TabContentContainer,
  TabContentTitleContainer,
} from './TabContent.styled';

export function TabContent ({ title, subTitle, children }: ITabContent) {
  return (
    <TabContentContainer>
      <TabContentTitleContainer>
        <Headline3 color="verdigrisDark" ellipsis={true}>
          {title && title}
        </Headline3>
        {subTitle && <SubTitle>{subTitle}</SubTitle>}
      </TabContentTitleContainer>
      {children}
    </TabContentContainer>
  );
}
